import Head from 'next/head';
import {
    isOkToLoad
} from '../../utils/isOkToLoad';

const TrackingScripts = () => (
    <Head>
        {isOkToLoad && (
            <link
                rel="preconnect"
                href="https://dev.visualwebsiteoptimizer.com"
            />
        )}
        {isOkToLoad && (
            <script
                id="vwoCode"
                defer
                dangerouslySetInnerHTML={{
                    __html: `
                window._vwo_code || (function() {
                var account_id=${process.env.NEXT_PUBLIC_VWO_ACCOUNT_ID},
                version=2.0,
                settings_tolerance=2000,
                hide_element='body',
                hide_element_style = 'opacity:0 !important;filter:alpha(opacity=0) !important;background:none !important',
                /* DO NOT EDIT BELOW THIS LINE */
                f=false,w=window,d=document,v=d.querySelector('#vwoCode'),cK='_vwo_'+account_id+'_settings',cc={};try{var c=JSON.parse(localStorage.getItem('_vwo_'+account_id+'_config'));cc=c&&typeof c==='object'?c:{}}catch(e){}var stT=cc.stT==='session'?w.sessionStorage:w.localStorage;code={use_existing_jquery:function(){return typeof use_existing_jquery!=='undefined'?use_existing_jquery:undefined},library_tolerance:function(){return typeof library_tolerance!=='undefined'?library_tolerance:undefined},settings_tolerance:function(){return cc.sT||settings_tolerance},hide_element_style:function(){return'{'+(cc.hES||hide_element_style)+'}'},hide_element:function(){return typeof cc.hE==='string'?cc.hE:hide_element},getVersion:function(){return version},finish:function(){if(!f){f=true;var e=d.getElementById('_vis_opt_path_hides');if(e)e.parentNode.removeChild(e)}},finished:function(){return f},load:function(e){var t=this.getSettings(),n=d.createElement('script'),i=this;if(t){n.textContent=t;d.getElementsByTagName('head')[0].appendChild(n);if(!w.VWO||VWO.caE){stT.removeItem(cK);i.load(e)}}else{n.fetchPriority='high';n.src=e;n.type='text/javascript';n.onerror=function(){w._vwo_code.finish()};d.getElementsByTagName('head')[0].appendChild(n)}},getSettings:function(){try{var e=stT.getItem(cK);if(!e){return}e=JSON.parse(e);if(Date.now()>e.e){stT.removeItem(cK);return}return e.s}catch(e){return}},init:function(){if(d.URL.indexOf('__vwo_disable__')>-1)return;var e=this.settings_tolerance();w._vwo_settings_timer=setTimeout(function(){w._vwo_code.finish();stT.removeItem(cK)},e);var t=d.currentScript,n=d.createElement('style'),i=this.hide_element(),r=t&&!t.async&&i?i+this.hide_element_style():'',c=d.getElementsByTagName('head')[0];n.setAttribute('id','_vis_opt_path_hides');v&&n.setAttribute('nonce',v.nonce);n.setAttribute('type','text/css');if(n.styleSheet)n.styleSheet.cssText=r;else n.appendChild(d.createTextNode(r));c.appendChild(n);this.load('https://dev.visualwebsiteoptimizer.com/j.php?a='+account_id+'&u='+encodeURIComponent(d.URL)+'&vn='+version)}};w._vwo_code=code;code.init();})();(function(){var i=window;function t(){if(i._vwo_code){var e=t.hidingStyle=document.getElementById('_vis_opt_path_hides')||t.hidingStyle;if(!i._vwo_code.finished()&&!_vwo_code.libExecuted&&(!i.VWO||!VWO.dNR)){if(!document.getElementById('_vis_opt_path_hides')){document.getElementsByTagName('head')[0].appendChild(e)}requestAnimationFrame(t)}}}t()})();
                `
                }}
            />
        )}
        {isOkToLoad && (
            <script
                defer
                dangerouslySetInnerHTML={{
                    __html: `
                        !function(f,b,e,v,n,t,s)
                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', '276794426891651');
                        fbq('init', '1577925039847400');
                        fbq('track', 'PageView');
                    `
                }}
            />
        )}
        {isOkToLoad && (
            <noscript>
                <img
                    height="1"
                    width="1"
                    style={{
                        display: 'none'
                    }}
                    src="https://www.facebook.com/tr?id=276794426891651&ev=PageView&noscript=1"
                />
            </noscript>
        )}
        {isOkToLoad && (
            <noscript>
                <img
                    height="1"
                    width="1"
                    style={{
                        display: 'none'
                    }}
                    src="https://www.facebook.com/tr?id=1577925039847400&ev=PageView&noscript=1"
                />
            </noscript>
        )}
        {isOkToLoad && (
            <script
                defer
                dangerouslySetInnerHTML={{
                    __html: `
                        !function(e,t,o){e.TiktokAnalyticsObject=o;var i=e[o]=e[o]||[];i.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],i.setAndDefer=function(e,t){e[t]=function(){e.push([t].concat(Array.prototype.slice.call(arguments,0)))}};for(var n=0;n<i.methods.length;n++)i.setAndDefer(i,i.methods[n]);i.instance=function(e){for(var t=i._i[e]||[],n=0;n<i.methods.length;n++)i.setAndDefer(t,i.methods[n]);return t},i.load=function(e,t){var n="https://analytics.tiktok.com/i18n/pixel/events.js";i._i=i._i||{},i._i[e]=[],i._i[e]._u=n,i._t=i._t||{},i._t[e]=+new Date,i._o=i._o||{},i._o[e]=t||{},(t=document.createElement("script")).type="text/javascript",t.async=!0,t.src=n+"?sdkid="+e+"&lib="+o,(e=document.getElementsByTagName("script")[0]).parentNode.insertBefore(t,e)},i.load("${process.env.NEXT_PUBLIC_TIK_TOK_PIXEL_ID}"),i.page()}(window,document,"ttq")
                `
                }}
            />
        )}
    </Head>
);

export default TrackingScripts;
